<template>
  <div class="mobile-header">
    <router-link :to="'/dashboard'" class="logo">
        <img src="@/assets/small-logo.png" alt="logo" width="131" height="132" />
    </router-link>
    <div class="toggle-sidebar" @click="toggleActive">
      <i class="material-icons">menu</i>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  methods: {
    toggleActive() {
      this.$store.dispatch('sidebar/toggleActive');
    }
  }
}
</script>

<style lang="scss" scoped>
@media (min-width:1101px) {
  .mobile-header {
    display: none;
  }
}
@media (max-width:1100px) {
  .mobile-header {
    width: 100%;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 8px;
    background-color: #fff;
    .logo {
      display: flex;
      img {
        width: 50px;
        height: auto;
      }
    }
    .toggle-sidebar {
      display: flex;
      cursor: pointer;
      user-select: none;
      i {
        font-size: 32px;
      }
      &.is_active {

      }
    }
  }
}
</style>
